export class AppGlobalService {
  public static loginID: string;
}
